import * as React from 'react';
import * as ReactDOM from 'react-dom';
import InClientStorePanel from '../components/InClientStorePanel';
import initializeStore from 'owa-addins-marketplace/lib/InitAddinStore';

let StorePaneContainer: HTMLDivElement;

StorePaneContainer = document.createElement('div');
document.body.appendChild(StorePaneContainer);

export default function openInClientStore() {
    initializeStore().then(storeUrl => {
        const storeUrlString = storeUrl as string;
        const InClientStorePanelElement = React.createElement(InClientStorePanel, {
            storeUrl: storeUrlString,
        });

        const inClientStoreElement = ReactDOM.render(InClientStorePanelElement, StorePaneContainer);

        inClientStoreElement.setPanelOpen();
    });
}
